<ngx-loading-bar color="#329898"></ngx-loading-bar>
